import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_bookmark",
  "use": "svg_bookmark-usage",
  "viewBox": "0 0 12 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 15\" id=\"svg_bookmark\"><path d=\"M0 0v14.9l5-4.7V8.6l-3.8 3.5V1.2h9.6v10.9L7 8.6v1.6l5 4.7V0H0Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol